module.exports = __webpack_public_path__ + "static/img/image@2x (11).2b0be278.png";